import React from 'react';

import { useSelector } from 'react-redux';

import { itineraryDetailsModeSelector } from 'store/itinerariesItem/selectors';

import { EDetailsMode } from '../../Itinerary/Details/types';
import GPLandingBuilderV1 from './V1';
import GPLandingBuilderV2 from './V2';

function Landing() {
  const detailsMode = useSelector(itineraryDetailsModeSelector);

  switch (detailsMode) {
    case EDetailsMode.Chronological:
      return <GPLandingBuilderV2 />;
    default:
      return <GPLandingBuilderV1 />;
  }
}

export default Landing;
